import {createContext, useContext} from "react";

export type SessionContextInterface = {
    isAuthenticated: boolean
    userId: string | null                // <--- HINZUGEFÜGT
    login: (key: string) => Promise<void>
    logout: () => void
    userData: any
    writeUserData: (data: any) => Promise<void>
    getGroupData: () => Promise<any>
    getGlobalData: () => Promise<any>
}

const errorMessageFn = (..._: undefined[]) => console.error("SessionContext not initialized");

export const SessionContext = createContext<SessionContextInterface>({
    isAuthenticated: false,
    userId: null,                        // <--- HINZUGEFÜGT
    login: async () => errorMessageFn(),
    logout: errorMessageFn,
    userData: null,
    writeUserData: async () => errorMessageFn(),
    getGroupData: async () => {
        errorMessageFn();
        return null;
    },
    getGlobalData: async () => {
        errorMessageFn();
        return null;
    }
});

export const useSession = () => useContext(SessionContext);